import React from 'react'
import StatCard from './StatCard'

const EventTypeGrid = ({ eventsByType }) => {
  const eventTypes = [
    { key: 'festival', emoji: '🎪', label: 'Festivals' },
    { key: 'concert', emoji: '🎵', label: 'Concerts' },
    { key: 'streaming', emoji: '📺', label: 'Streaming' },
    { key: 'private', emoji: '🏠', label: 'Private' }
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {eventTypes.map((type) => (
        <StatCard
          key={type.key}
          emoji={type.emoji}
          value={eventsByType[type.key] || 0}
          label={type.label}
        />
      ))}
    </div>
  )
}

export default EventTypeGrid